export default __webpack_public_path__ + "static/desktop-5aff97c0421e0fccb7c820d2ad0e5007.jpg";